import jwtDecode from 'jwt-decode';

const getRegionApiSubdomain = regionName => {
	const validRegions = ['CAD', 'US', 'can', 'usa', 'staging', 'dev'];

	if (!validRegions.includes(regionName)) {
		window.location.replace('/login');
		throw new Error(`invalid region: ${regionName}`);
	}

	if (regionName === 'usa' || regionName === 'US') {
		return `usa-region-api`;
	} else if (regionName === 'can' || regionName === 'CAD') {
		return `can-region-api`;
	} else {
		// e.g. dev-api, staging-api
		return `${regionName}-api`;
	}
};

export const getApiHost = () => {
	if (process.env.REACT_APP_API_HOST) {
		return process.env.REACT_APP_API_HOST;
	}

	try {
		const jwt = jwtDecode(localStorage.wiselyToken);
		const subdomain = getRegionApiSubdomain(jwt.organization_region);
		return `https://${subdomain}.wiselysoftware.com`;
	} catch (e) {
		console.log('failed to get api host');
		throw e;
	}
};



// WEBPACK FOOTER //
// ./src/envConfig.js